import { Link } from 'react-router-dom';
import { Mail, MapPin, Globe } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ignite-scale/artifacts/ij3ii683_file_00000000c58471f89c8c9afa889bdef4.png';

const footerLinks = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Industries', path: '/industries' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-[#070918] border-t border-[#FF8C28]/10">
      {/* Glow line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-[#E65A14] to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <img src={LOGO_URL} alt="EmberCore Digital" className="h-24 w-auto" />
            </Link>
            <p className="text-[#8A8D9F] text-sm leading-relaxed max-w-xs">
              Building intelligent digital systems that simplify complexity and drive growth.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-bold tracking-[0.15em] uppercase text-[#FF8C28] mb-6">
              Quick Links
            </h4>
            <nav className="space-y-3">
              {footerLinks.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="block text-sm text-[#C8C8C8] hover:text-[#FF8C28] transition-colors duration-200"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-sm font-bold tracking-[0.15em] uppercase text-[#FF8C28] mb-6">
              Get in Touch
            </h4>
            <div className="space-y-4">
              <a
                href="mailto:info@embercoredigital.co.za"
                data-testid="footer-email"
                className="flex items-center gap-3 text-sm text-[#C8C8C8] hover:text-[#FF8C28] transition-colors"
              >
                <Mail size={16} className="text-[#E65A14] flex-shrink-0" />
                info@embercoredigital.co.za
              </a>
              <div className="flex items-center gap-3 text-sm text-[#C8C8C8]">
                <Globe size={16} className="text-[#E65A14] flex-shrink-0" />
                embercoredigital.co.za
              </div>
              <div className="flex items-center gap-3 text-sm text-[#C8C8C8]">
                <MapPin size={16} className="text-[#E65A14] flex-shrink-0" />
                South Africa
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#8A8D9F]">
            &copy; {new Date().getFullYear()} EmberCore Digital. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-[#8A8D9F]">Privacy Policy</span>
            <span className="text-xs text-[#8A8D9F]">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
